import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SeveridadeToast } from '../../models/enums/severidade-toast.enum';
import { AlteraSenhaRequest } from '../../models/alteraSenhaRequest.model';
import { AuthService } from '../../services/auth.service';
import { ToastService } from '../../services/toast.service';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  token!: string;
  email!: string;
  form!: FormGroup;
  loading = false;
  submitted = false;
  alteraSenha: AlteraSenhaRequest = new AlteraSenhaRequest

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService,
    private authService: AuthService,
    private spinnerService: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.form = new FormGroup({
        senha: new FormControl('', [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(50),
          Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[!@#$%^&*(),.?":{}|<>]).+$')
        ]),
        senhaConfirmacao: new FormControl('', Validators.required),
        token: new FormControl(params['token']),
        email: new FormControl(params['email'])
      });
    });
  }

  get f() {
    return this.form.controls as {
      senha: FormControl;
      confirmPassword: FormControl;
      token: FormControl;
    };
  }

  onSubmit() {
    this.spinnerService.show();
    if (this.form.invalid) return;

    this.alteraSenha = this.form.getRawValue() as AlteraSenhaRequest;
    this.authService.resetarSenha(this.alteraSenha)
      .subscribe({
        next: (res) => {
          this.router.navigate(["/"]);
          this.retornarMensagemSucesso(res.message);
          this.spinnerService.hide();
        },
        error: (e) => {
          this.retornarMensagemErro(e);
          this.spinnerService.hide();
        }
      });
  }

  retornarMensagemSucesso(mensagem: string) {
    this.toastService.setMensagemToast(mensagem, SeveridadeToast.Success);
  }

  retornarMensagemErro(e: any) {
    this.toastService.setMensagemToast('Erro ao redefinir senha:' + e.error + '!', SeveridadeToast.Error);
  }
}
